import React, { useState, useEffect } from "react";
import { FormContent } from "./styled"
import axios from "axios";
import 'react-calendar/dist/Calendar.css';
import { Button, Form, Input, Flex, DatePicker, Space, Checkbox, Tooltip, Radio, ConfigProvider, Modal, Skeleton } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { SaveOutlined, DeleteOutlined, DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { formatCNPJ, formatValueBrl2 } from "../../../../../../function/utilis/function.js"
import CircularProgress from '@mui/material/CircularProgress';
import { TfiWorld } from "react-icons/tfi";
import ModalExcluirTarefa from "./ModalExcluirTarefa/index.jsx";
import { FormatItem } from "../styled.jsx";

import CredenciaisAcesso from "../PendentesEmitir/CredenciaisDeAcesso/index.jsx";
import NotaFiscal from "../../../../NotaFiscal/index.jsx";
import { Method_POST_REST } from "../../../../../../service/api.js";
import UploadDoc from "./UploadDoc/index.jsx";
import { TabelaCorrelacionadas } from "./TabelaCorrelacionada/index.jsx";
import { IoAddOutline, IoEyeOutline } from "react-icons/io5";
import ModalAdicionarInformacoes from "../ModalAdicionarInformaçoes/index.jsx";

import "./style.css"

export function EmitidasEditar({ isOpen,
    onClose,
    taskId,
    id,
    recorrencia,
    data,
    clienteId,
    emitidas,
    pendentes,
    obrigacaoId,
}) {
    const [form] = Form.useForm();
    const [isDisabled] = useState(true);
    const [loadings, setLoadings] = useState([]);
    const [isOptionsMotivo, setIsOptionsMotivo] = useState([]);
    const [fileId, setFileId] = React.useState(null);
    const [isTaskId] = useState(taskId);
    const [isObrigacaoId] = useState(obrigacaoId);

    const getOptions = () => {
        const returno = isOptionsMotivo.filter(
            (option) => formulario.situacao[0] === option.value[0]
        );
        return returno;
    };
    const [formulario, setFormulario] = useState({
        clienteId: "",
        clienteCnpj: "",
        nomeRazaoSocial: "",
        inscricaoEstadual: "",
        inscricaoMunicipal: "",
        cnaeAnexos: "",
        obrigacao: "",
        sigla: "",
        nome: "",
        dataReferencia: "",
        dataVencimento: "",
        valor: "",
        disponibilizacaoPortal: true,
        urlSite: "",
        situacao: "",
        motivo: "",
        descricao: "",

        dataLiberacao: "",

        dataEmissao: "",
        dataUltimaNotificacao: "",
        dataConhecimento: "",
        dataDownload: "",

        dataUltimaNotificacaoAtrasoEmail: "",
        dataUltimaNotificacaoAtrasoWhatsapp: "",
        dataUltimaNotificacaoEmail: "",
        dataUltimaNotificacaoWhatsapp: "",

        motivoLiberacao: "",
        qtdNotificacoes: "",
        usuarioEmissao: "",
        usuarioDownload: "",
        usuarioLiberacao: "",
        usuarioConhecimento: "",
        liberado: "",



    });
    const [SituacaoMotivo, setSituacaoMotivo] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [open, setOpen] = useState(false);
    const [documentoToDelete, setDocumentoToDelete] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);

    const [isTarefaCorrelacionada, setIsTarefaCorrelacionada] = useState(false);
    const [tarefasCorrelacionadas, setTarefasCorrelacionadas] = useState([]);
    
    const [isRender, setIsRender] = useState(false);

    const [files, setIsFiles] = useState([]);
    const [isFile, setIsFile] = useState({});
    const [isFileName, setIsFileName] = useState();
     const [retificacaoFile, setRetificacao] = useState({
        "DATA_COMPETENCIA": "",
        "FORMATO_ARQUIVO": "",
        "CNPJ": "",
        "VALOR_GUIA": "",
        "DATA_VENCIMENTO_GUIA": ""
      })
      const [isValidate, setIsvalidate] = useState(true);
       const [isModalConfirmRetificacao, setIsModalConfirmRetificacao] = useState(false);
       const [isLoadingConfirmeValorGuia, setIsLoadingConfirmeValorGuia] = useState(false);
        const [disableValue, setDisableValue] = useState();

    const [selectedOption, setSelectedOption] = useState('cadastro');

    const [armazCorrelacionais, setArmazCorrelacionais] = useState();

    const [isModalAddInformacoesAdicionais, setIsModalAddInformacoesAdicionais] = useState(false);

    useEffect(() => {
        let height = document.documentElement.scrollHeight;
        window.parent.postMessage({ frameHeight: height, scrollUp: true }, "*");
    });

    useEffect(() => {
        carregarDocumentosExistents(taskId);
    }, []);

    useEffect(() => {
        consultarObrigacao(taskId, obrigacaoId);
    }, []);

    const consultarObrigacao = async (taskId, obrigacaoId) => {
        const url = "/portal/rest/contador/obrigacao/consultar"
        const data = {
            id: String(taskId)
        }

        setIsLoadingForm(true);
        try {
            const response = await axios.post(url, data, { withCredentials: true });

            console.log("Ddaos mostrado: ", response.data);

            const dataReferenciaFormat = dayjs(response.data.dataReferencia).format('YYYY-MM-DD');
            const dataVencimentoFormat = dayjs(response.data.dataVencimento).format('YYYY-MM-DD');

            const dataLiberacao = dayjs(response.data.dataLiberacao).format('YYYY-MM-DD');
            const dataEmissao = dayjs(response.data.dataEmissao).format('YYYY-MM-DD HH:mm:ss');
            const dataDownload = dayjs(response.data.dataDownload).format('YYYY-MM-DD HH:mm:ss');
            const dataUltimaNotificacao = dayjs(response.data.dataUltimaNotificacao).format('YYYY-MM-DD HH:mm:ss');
            const dataConhecimento = dayjs(response.data.dataConhecimento).format('YYYY-MM-DD HH:mm:ss');
            const dataUltimaNotificacaoAtrasoEmail = dayjs(response.data.dataUltimaNotificacaoAtrasoEmail).format('YYYY-MM-DD HH:mm:ss');
            const dataUltimaNotificacaoAtrasoWhatsapp = dayjs(response.data.dataUltimaNotificacaoAtrasoWhatsapp).format('YYYY-MM-DD HH:mm:ss');
            const dataUltimaNotificacaoEmail = dayjs(response.data.dataUltimaNotificacaoEmail).format('YYYY-MM-DD HH:mm:ss');
            const dataUltimaNotificacaoWhatsapp = dayjs(response.data.dataUltimaNotificacaoWhatsapp).format('YYYY-MM-DD HH:mm:ss');


            const motivos = response.data.obrigacao.motivos.map(motivo => ({
                value: motivo.id,
                label: motivo.nome
            }));
            const situacaoValida = response.data.obrigacao.situacoes.map(motivo => ({
                value: motivo.id,
                label: motivo.nome
            }));
            setSituacaoMotivo(situacaoValida);
            console.log(response.data);

            setIsOptionsMotivo(motivos);
            const { cliente } = response.data;
            const { obrigacao } = response.data;
            const { situacao } = response.data;
            const { motivoLiberacao } = response.data;
            const { usuarioEmissao } = response.data;
            const { usuarioDownload } = response.data;
            const { usuarioLiberacao } = response.data;
            const { usuarioConhecimento } = response.data



            setFormulario(prevState => ({
                ...prevState,
                clienteId: cliente.id,
                clienteCnpj: cliente.cnpj,
                nomeRazaoSocial: cliente.nome,
                inscricaoEstadual: cliente.ie,
                inscricaoMunicipal: cliente.im,
                cnaeAnexos: cliente.cnaeAnexos,
                obrigacao: obrigacao.id,
                sigla: obrigacao.sigla,
                nome: obrigacao.nome,
                situacao: situacao.nome,
                motivo: response.data.motivo.id,
                descricao: response.data.descricao,
                valor: response.data.valor,
                urlSite: obrigacao.urlPrefeitura,
                dataReferencia: dataReferenciaFormat,
                dataVencimento: dataVencimentoFormat,

                dataLiberacao: dataLiberacao,
                liberado: response.data.liberado,
                dataEmissao: dataEmissao,
                dataDownload: dataDownload,
                dataUltimaNotificacao: dataUltimaNotificacao,
                dataConhecimento: dataConhecimento,
                dataUltimaNotificacaoAtrasoEmail: dataUltimaNotificacaoAtrasoEmail,
                dataUltimaNotificacaoEmail: dataUltimaNotificacaoEmail,
                dataUltimaNotificacaoAtrasoWhatsapp: dataUltimaNotificacaoAtrasoWhatsapp,
                dataUltimaNotificacaoWhatsapp: dataUltimaNotificacaoWhatsapp,

                motivoLiberacao: motivoLiberacao.id,
                usuarioEmissao: usuarioEmissao.id,
                qtdNotificacoes: response.data.qtdNotificacoes,
                usuarioDownload: usuarioDownload.id,
                usuarioLiberacao: usuarioLiberacao.id,
                usuarioConhecimento: usuarioConhecimento.id
            }));

            const correlacionais = response.data.correlacionadas?.[0] || null;

            if (correlacionais) {
                setArmazCorrelacionais(correlacionais);

                const dadosFormatados = {
                    idObg: response.data.obrigacao.id,
                    dataVencimentoObg: correlacionais.dataVencimento,
                    obrgId: correlacionais.obrigacao?.id,
                    obrigacaoSigla: correlacionais.obrigacao?.sigla,
                    descricao: correlacionais.descricao,
                    obrigacaoNome: correlacionais.obrigacao?.nome,
                    situacaoNome: correlacionais.situacao?.nome,
                };
                setTarefasCorrelacionadas([dadosFormatados]);
            } else {
                setIsTarefaCorrelacionada(false);
            }

            //console.log("correlacionais: ", correlacionais);

            // Verificação da situação e se há correlacionais
            if (situacao.id !== "S") {
                setIsTarefaCorrelacionada(false);
            } else {
                setIsTarefaCorrelacionada(true);
            }
            if (correlacionais.length === 0) {
                setIsTarefaCorrelacionada(false);
            }

        } catch {
            //toast.error("Não foi possível trazer os dados da obrigação.");
            setIsTarefaCorrelacionada(false);
        } finally {
            setIsLoadingForm(false);
        }

    }

    //apliquei o service
  const carregarDocumentosExistents = async (taskId) => {
    const url = 'contador/obrigacao/arquivo/listar';
    const data = {
      id: taskId
    };
    setExporting(true);

    try {
      const response = await Method_POST_REST(url, data);


      const arquivos = response.files.map(filePath => {
        return filePath.split('\\').pop().split('/').pop();
      });
      console.log("arquivos extraídos:", arquivos);
      setDocumentos(arquivos);


    } catch (error) {
      toast.error('Erro ao carregar documentos existentes.');
    } finally {
      setExporting(false);
    }
  };

    const atualizarObrigacao = async () => {
        let valorSanitizado = String(formulario.valor).replace("R$ ", "").replace(/\./g, "").replace(",", ".");
        let result = parseFloat(valorSanitizado)*100;
        


        const url = "/portal/rest/contador/obrigacao/atualizar";
        const param = {
            id: isTaskId.toString(),
            cliente: {},
            obrigacao: {},
            dataReferencia: dayjs(formulario.dataReferencia),
            dataVencimento: dayjs(formulario.dataVencimento),
            situacao: {
                id: formulario.situacao === "Emitida"
                    ? "E"
                    : formulario.situacao === "Sem Movimento"
                        ? "S"
                        : formulario.situacao === "Justificada"
                            ? "J"
                            : ""
            },
            nome: formulario.nome,
            descricao: formulario.descricao,
            valor: result,
            liberado: formulario.liberado,
            motivoLiberacao: {
                id: formulario.motivoLiberacao,
            },
            dataLiberacao: dayjs(formulario.dataLiberacao),
            usuarioLiberacao: {
                id: formulario.usuarioLiberacao,
            },
        };

        //verifica se tem arquivo no documentos e se existe algum arquivo importado 
        if(documentos.length === 0 && !fileId){
            toast.error("Você precisa importar um documento, para salvar");
            return;
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });

            if (response.status === 204) {
                toast.success("Guia Imposto/Declaração salvo com sucesso!");
                await consultarObrigacao(isTaskId, obrigacaoId);

                emitidas(id, recorrencia, data, clienteId);
                pendentes(id, recorrencia, data, clienteId);

                onclose();
            } else {
                throw new Error("Status inesperado da resposta");
            }
        } catch (error) {
            if (error.response && error.response.status !== 204) {
                toast.error("Não foi possível realizar a ação, revise os dados e tente novamente em alguns segundos.");
            }
        }
    };

    const enterLoading = async (index) => {
        // Inicia o loading
        setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = true;
            return newLoadings;
        });

        // Chama a função atualizarObrigacao
        await atualizarObrigacao();

        // Finaliza o loading após o atualizarObrigacao ser concluído
        setLoadings((prevLoadings) => {
            const newLoadings = [...prevLoadings];
            newLoadings[index] = false;
            return newLoadings;
        });

        // Chama a função carregarDocumentosExistents após o loading ser desativado
        carregarDocumentosExistents(taskId);
    };

      const handleView = async (doc, index) => {
        const docSplit = doc.split('\\').pop().split('/').pop();
        const fileName = docSplit;

        const url = `/portal/rest/contador/obrigacao/arquivo/view?id=${index}&filename=${fileName}`;

        setExporting(true);
        try {
            window.open(url, '_blank');

        } catch (error) {
            toast.error("Não foi possível visualizar o arquivo", error);
            setExporting(false);
        } finally {
            setExporting(false);
        }
    }

    const handleDownload = async (documento) => {
        const filenameWithoutPath = documento.split('\\').pop().split('/').pop();
        const fileName = filenameWithoutPath;

        setExporting(true);
        try {
            const response = await axios.get(`/portal/rest/contador/obrigacao/arquivo/download?id=${isTaskId}&filename=${fileName}`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Usar fileName para o download
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Erro ao baixar arquivo:', error);
            toast.error('Erro ao baixar arquivo.');
        } finally {
            setExporting(false);
        }
    };

    const handleDelete = async () => {
        if (!documentoToDelete) return;
        const documento = documentoToDelete;
        
        
        const filenameWithoutPath = documento.split('\\').pop().split('/').pop() ;
        //const fileName = filenameWithoutPath.replace(/-(\d{2})(\d{4})\.pdf$/, ' $1 $2.pdf');
        
        console.log("documento: ", filenameWithoutPath);

        const fileEncoded = encodeURI(filenameWithoutPath);
        const fileDecoded = decodeURI(fileEncoded);
    
    
        const url = `/portal/rest/contador/obrigacao/arquivo/remover?id=${isTaskId}&filename=${fileEncoded}`;
        const param = {
            id: filenameWithoutPath
        };
    
        setConfirmLoading(true);
        setExporting(true);
        try {
            const response = await axios.post(url, param, { withCredentials: true });
    
            if (response.status === 204) {
                // Usando o nome decodificado para mensagens amigáveis
                toast.success(`Arquivo "${fileDecoded}" excluído com sucesso.`);
                consultarObrigacao(isTaskId, isObrigacaoId);
                carregarDocumentosExistents(isTaskId);
            } else {
                toast.error('Falha ao excluir o arquivo.');
            }
        } catch (error) {
            console.error('Erro ao excluir o arquivo:', error);
            toast.error('Erro ao excluir o arquivo.');
        }
        setConfirmLoading(false);
        setExporting(false);
        setOpen(false);
    };

    const handleSite = () => {
        if (formulario.obrigacao && formulario.urlSite) {
            window.open(formulario.urlSite, '_blank');
        } else {
            toast.info('URL não está disponível.');
            toast.info("url", formulario.urlSite);
        }
    }

    const handleSituacaoChange = (value) => {
        setFormulario(prevState => {
            let descricao = '';

            switch (value) {
                case 'Emitida':
                    descricao = `${prevState.nome} - ref. ${dayjs(prevState.dataReferencia).format('MM/YYYY')}`;
                    break;
                case 'Justificada':
                    descricao = `JUSTIFICADA - ref. ${dayjs(prevState.dataReferencia).format('MM/YYYY')}`;
                    break;
                case 'Sem Movimento':
                    descricao = `SEM MOVIMENTAÇÃO - ref. ${dayjs(prevState.dataReferencia).format('MM/YYYY')}`;
                    break;
                default:
                    descricao = '';
                    break;
            }

            return {
                ...prevState,
                situacao: value,
                descricao: descricao,
            };
        });

        if (value === "Emitida" || value === "Justificada") {
            setIsRender(true);
        } else {
            setIsRender(false);
        }
    };

    const dasButton = obrigacaoId === 7 ? <Radio.Button value="das">DAS</Radio.Button> : null;

    const showModalDelete = (documento) => {
        setDocumentoToDelete(documento);
        setOpen(true);
    };

    const handleClose = () => {
        setIsModalDeleteOpen(false);
        onClose();
    };

    return (
      <Modal
        title="Edição de Guia de Imposto/Declaração"
        width="85%"
        open={isOpen}
        onCancel={onClose}
        footer={[
          <Button key="close" onClick={onClose}>
            Fechar
          </Button>,
        ]}
      >
        <div>
          <Form form={form} layout="vertical">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Form.Item>
                <Radio.Group
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <Radio.Button value="cadastro">Cadastro</Radio.Button>
                  <Radio.Button value="credenciais">
                    Credenciais de acesso
                  </Radio.Button>
                  {dasButton}
                </Radio.Group>
              </Form.Item>
            </div>
            <>
              {selectedOption === "cadastro" && (
                <>
                  {isLoadingForm ? (
                    <>
                      {[...Array(3)].map((_, index) => (
                        <Skeleton
                          active
                          key={index}
                          variant="rectangular"
                          width="100%"
                          height={8}
                          style={{ padding: "5px 20px" }}
                        />
                      ))}
                    </>
                  ) : (
                    <FormContent>
                      <div style={{ display: "flex", justifyContent: "right" }}>
                        <Tooltip title="Adicionar informações">
                          <div
                            className="btn-model width bg-padrao"
                            onClick={() =>
                              setIsModalAddInformacoesAdicionais(true)
                            }
                          >
                            <IoAddOutline />
                          </div>
                        </Tooltip>

                        <Tooltip title="Site da Prefeitura">
                          <div className="btn-model width" onClick={handleSite}>
                            <TfiWorld />
                          </div>
                        </Tooltip>
                      </div>

                      <div className="form-content">
                        <div>
                          <Form.Item
                            className="form-item"
                            label="Cliente"
                            name="cliente"
                            style={{ width: 60 }}
                          >
                            <Input
                              placeholder={
                                formulario.clienteId === null ||
                                formulario.clienteId === ""
                                  ? "Cliente"
                                  : formulario.clienteId
                              }
                              disabled={true}
                            />
                          </Form.Item>
                        </div>
                        <Form.Item
                          className="form-item"
                          label="CNPJ"
                          name="cpnj"
                        >
                          <Input
                            placeholder={
                              formulario.clienteCnpj === null ||
                              formulario.clienteCnpj === ""
                                ? "CNPJ"
                                : formatCNPJ(formulario.clienteCnpj)
                            }
                            disabled={true}
                          />
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Nome / Razão Social"
                          name="nome-razao"
                          style={{ width: 450 }}
                        >
                          <Input
                            placeholder={
                              formulario.nomeRazaoSocial === null ||
                              formulario.nomeRazaoSocial === null
                                ? "Nome / Razão Social"
                                : formulario.nomeRazaoSocial
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Inscrição Estadual"
                          name="ie"
                          style={{ width: 150 }}
                        >
                          <Input
                            placeholder={
                              formulario.inscricaoEstadual === null ||
                              formulario.inscricaoEstadual === ""
                                ? "Incrição Estadual"
                                : formulario.inscricaoEstadual
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Inscrição Municipal"
                          name="im"
                          style={{ width: 150 }}
                        >
                          <Input
                            placeholder={
                              formulario.inscricaoMunicipal === null ||
                              formulario.inscricaoMunicipal === ""
                                ? "Inscrição Municipal"
                                : formulario.inscricaoMunicipal
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="CNAE Anexos"
                          name="cnae"
                          style={{ width: 150 }}
                        >
                          <Input
                            placeholder={
                              formulario.cnaeAnexos === "" ||
                              formulario.cnaeAnexos === null
                                ? "CNAE Anexos"
                                : formulario.cnaeAnexos
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Obrigação"
                          name="obrigacao"
                          style={{ width: 50 }}
                        >
                          <Input
                            placeholder={
                              formulario.obrigacao === null ||
                              formulario.obrigacao === ""
                                ? "Obrigação"
                                : formulario.obrigacao
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Sigla"
                          name="sigla"
                        >
                          <Input
                            placeholder={
                              formulario.sigla === null ||
                              formulario.sigla === ""
                                ? "Sigla"
                                : formulario.sigla
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Nome"
                          name="nome"
                          style={{ width: 400 }}
                        >
                          <Input
                            placeholder={
                              formulario.nome === null || formulario.nome === ""
                                ? "Nome"
                                : formulario.nome
                            }
                            disabled={isDisabled}
                          />
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Mês de Referência"
                          name="dataReferencia"
                          style={{ width: 150 }}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={dayjs(formulario.dataReferencia)}
                                format="MM/YYYY"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataReferencia: dateString,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Data Vencimento"
                          name="dataVencimento"
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={dayjs(formulario.dataVencimento)}
                                format="DD/MM/YYYY"
                                onChange={(date, dateString) => {
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataVencimento: dateString,
                                  }));
                                }}
                                disabled
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <FormatItem>
                          <div className="central-format-item">
                            <label htmlFor="situacao-select">Situação</label>
                            <select
                              id="situacao-select"
                              className="select-format"
                              placeholder="Selecione a Situação"
                              value={formulario.situacao}
                              onChange={(e) =>
                                handleSituacaoChange(e.target.value)
                              }
                            >
                              <option value="" disabled>
                                Selecione
                              </option>{" "}
                              {/* Placeholder option */}
                              {SituacaoMotivo.map((option) => (
                                <option key={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </FormatItem>

                        {isRender && (
                          <FormatItem>
                            <div className="central-format-item">
                              <label htmlFor="situacao-select">Motivo</label>
                              <select
                                id="situacao-select"
                                className="select-format"
                                placeholder="Selecione o Motivo"
                                onChange={(e) =>
                                  setFormulario({
                                    ...formulario,
                                    motivo: e.target.value,
                                  })
                                }
                                value={formulario.motivo}
                              >
                                <option value="" disabled>
                                  Selecione
                                </option>
                                {getOptions().map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </FormatItem>
                        )}

                        <Form.Item
                          className="form-item"
                          label="Descrição"
                          name="descricao"
                          style={{ width: "280px" }}
                        >
                          <Input
                            placeholder={formulario.descricao}
                            //defaultValue={formulario.descricao}
                            disabled={true}
                            onChange={(e) =>
                              setFormulario({
                                ...formulario,
                                descricao: e.target.value,
                              })
                            }
                          />
                        </Form.Item>

                        <div>
                          <label style={{ position: "relative", top: "10px" }}>
                            Valor
                          </label>
                          <br />

                          <Input
                            style={{
                              width: 230,
                              height: 35,
                              position: "relative",
                              top: "15px",
                            }}
                            value={formatValueBrl2(String(formulario.valor))} // Mostra o valor formatado
                            onChange={(event) => {
                              let inputValue = event.target.value;

                              // Remove caracteres inválidos e formata em tempo real
                              const formattedValue =
                                formatValueBrl2(inputValue);

                              // Atualiza o estado com o valor formatado
                              setFormulario((prevState) => ({
                                ...prevState,
                                valor: formattedValue,
                              }));
                            }}
                          />
                        </div>

                        <Form.Item
                          className="form-item"
                          label="Disponibilização Portal"
                          name="disponibilizacao"
                        >
                          <Checkbox
                            checked={formulario.liberado}
                            onChange={(event) =>
                              setFormulario((prevState) => ({
                                ...prevState,
                                liberado: event.target.checked,
                              }))
                            }
                          >
                            Liberado
                          </Checkbox>
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <FormatItem>
                          <div className="central-format-item">
                            <label htmlFor="situacao-select">
                              Motivo Liberação
                            </label>
                            <select
                              id="situacao-select"
                              className="select-format"
                              placeholder="Selecione"
                              value={formulario.motivoLiberacao}
                              onChange={(e) =>
                                setFormulario((prevState) => ({
                                  ...prevState,
                                  motivoLiberacao: e.target.value,
                                }))
                              }
                            >
                              <option value="" disabled>
                                Selecione
                              </option>
                              <option value="MANUAL">
                                Emiss&atilde;o Manual
                              </option>
                              <option value="M-CONF">
                                Fechamento Confi&aacute;vel
                              </option>
                              <option value="M-CORR-DAS">
                                Corrigido - Sobrep&ocirc;s DAS
                              </option>
                              <option value="M-CORR-FAT-SM">
                                Corrigido - Sem Movimento mas apurou Com
                                Movimento
                              </option>
                              <option value="M-CORR-FAT-CM">
                                Corrigido - Com Movimento mas apurou Sem
                                Movimento
                              </option>
                              <option value="M-CORR-FAT-VL">
                                Corrigido - Valor de Faturamento Incorreto
                              </option>
                              <option value="M-CORR-FLH-VL">
                                Corrigido - Valor de Folha Incorreto
                              </option>
                              <option value="M-CORR-ANX-III">
                                Corrigido - Anexo III mas apurou outro anexo
                              </option>
                              <option value="M-CORR-ANX-IV">
                                Corrigido - Anexo IV mas apurou outro anexo
                              </option>
                              <option value="M-CORR-ANX-V">
                                Corrigido - Anexo V mas apurou outro anexo
                              </option>
                              <option value="M-CORR-NF-CANC">
                                Corrigido - Apurou Notas Cancelada
                              </option>
                              <option value="M-CORR-EXP-AP">
                                Corrigido - Apurou como Notas
                                Exporta&ccedil;&atilde;o
                              </option>
                              <option value="M-CORR-NF-MAN">
                                Corrigido - N&atilde;o apurou Notas Manuais
                              </option>
                              <option value="M-CORR-EXP-NAP">
                                Corrigido - N&atilde;o apurou Notas
                                Exporta&ccedil;&atilde;o
                              </option>
                              <option value="M-CORR-NF-RETR">
                                Corrigido - N&atilde;o apurou Notas Retroativa
                              </option>
                              <option value="M-CORR-NF-CI">
                                Corrigido - N&atilde;o apurou Notas
                                Com&eacute;rcio/Ind&uacute;stria
                              </option>
                              <option value="M-CORR-NF-DEV">
                                Corrigido - N&atilde;o apurou Notas
                                Devolu&ccedil;&atilde;o
                              </option>
                              <option value="M-CORR-ISS-RET">
                                Corrigido - ISS Retido n&atilde;o considerado
                              </option>
                              <option value="M-CORR-ISS-OM">
                                Corrigido - ISS Tributado Fora do
                                Munic&iacute;pio
                              </option>
                              <option value="M-CORR-ICMS-R">
                                Corrigido - ICMS com redu&ccedil;&atilde;o
                                n&atilde;o considerado
                              </option>
                              <option value="A-LIB-COMP">
                                Libera&ccedil;&atilde;o Autom&aacute;tica
                              </option>
                            </select>
                          </div>
                        </FormatItem>

                        <Form.Item
                          className="form-item"
                          label="Data Liberação"
                          name="dataLiberacao"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={dayjs(formulario.dataLiberacao)}
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataLiberacao: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Usuário Liberação"
                          name="usuarioLiberacao"
                        >
                          <Input
                            placeholder={
                              formulario.usuarioLiberacao === "" ||
                              formulario.usuarioLiberacao === null
                                ? "Usuário Liberação"
                                : formulario.usuarioLiberacao
                            }
                            disabled={true}
                          />
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Data Emissão"
                          name="dataEmissao"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataEmissao
                                    ? dayjs(formulario.dataEmissao)
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format("DD/MM/YYYY HH:mm:ss")
                                    : "DD/MM/YYYY HH:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataEmissao: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Usuário Emissão"
                          name="usuarioEmissao"
                        >
                          <Input
                            placeholder={
                              formulario.usuarioEmissao === null ||
                              formulario.usuarioEmissao === ""
                                ? "Usuário Emissão"
                                : formulario.usuarioEmissao
                            }
                            disabled={true}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Notificações"
                          name="qtdNotificacoes"
                        >
                          <Input
                            placeholder={
                              formulario.qtdNotificacoes === null ||
                              formulario.qtdNotificacoes === ""
                                ? "Notificações"
                                : formulario.qtdNotificacoes
                            }
                            disabled={true}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Data Última Notificação"
                          name="dataUltimaNotificacao"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataUltimaNotificacao
                                    ? dayjs(formulario.dataUltimaNotificacao)
                                    : null
                                }
                                format="DD/MM/YYYY HH:mm:ss"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format("DD/MM/YYYY HH:mm:ss")
                                    : "DD/MM/YYYY HH:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataUltimaNotificacao: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Data Conhecimento"
                          name="dataConhecimento"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataConhecimento
                                    ? dayjs(formulario.dataConhecimento)
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataConhecimento: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Usuário Conhecimento"
                          name="usuarioConhecimento"
                        >
                          <Input
                            placeholder={
                              formulario.usuarioConhecimento === null ||
                              formulario.usuarioConhecimento === ""
                                ? "Usuário Conhecimento"
                                : formulario.usuarioConhecimento
                            }
                            disabled={true}
                          />
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Data Último Download"
                          name="dataDownload"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataDownload
                                    ? dayjs(formulario.dataDownload)
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataDownload: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                        <Form.Item
                          className="form-item"
                          label="Usuário Download"
                          name="usuarioDownload"
                        >
                          <Input
                            placeholder={formulario.usuarioDownload}
                            disabled={true}
                          />
                        </Form.Item>
                      </div>
                      <div className="form-content">
                        <Form.Item
                          className="form-item"
                          label="Data Notif (e-mail)"
                          name="dataUltimaNotificacaoEmail"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataUltimaNotificacaoEmail
                                    ? dayjs(
                                        formulario.dataUltimaNotificacaoEmail
                                      )
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataUltimaNotificacaoEmail: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Data Notif (whatsapp)"
                          name="dataUltimaNotificacaoWhatsapp"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataUltimaNotificacaoWhatsapp
                                    ? dayjs(
                                        formulario.dataUltimaNotificacaoWhatsapp
                                      )
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataUltimaNotificacaoWhatsapp:
                                      formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Data Notif.Atraso (e-mail)"
                          name="dataUltimaNotificacaoAtrasoEmail"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataUltimaNotificacaoAtrasoEmail
                                    ? dayjs(
                                        formulario.dataUltimaNotificacaoEmail
                                      )
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataUltimaNotificacaoEmail: formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>

                        <Form.Item
                          className="form-item"
                          label="Data Notif.Atraso (whats)"
                          name="dataUltimaNotificacaoAtrasoWhatsapp"
                          disabled={true}
                        >
                          <Space direction="vertical">
                            <ConfigProvider locale={ptBR}>
                              <DatePicker
                                className="date-picker"
                                value={
                                  formulario.dataUltimaNotificacaoAtrasoWhatsapp
                                    ? dayjs(
                                        formulario.dataUltimaNotificacaoAtrasoWhatsapp
                                      )
                                    : null
                                }
                                format="DD/MM/YYYY : HH:mm:ss"
                                picker="month"
                                disabled
                                onChange={(date, dateString) => {
                                  const formattedDate = date
                                    ? dayjs(date).format(
                                        "DD/MM/YYYY : hh:mm:ss"
                                      )
                                    : "DD/MM/YYYY : hh:mm:ss";
                                  setFormulario((prevState) => ({
                                    ...prevState,
                                    dataUltimaNotificacaoAtrasoWhatsapp:
                                      formattedDate,
                                  }));
                                }}
                              />
                            </ConfigProvider>
                          </Space>
                        </Form.Item>
                      </div>
                      <div
                        className="form-content"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Form.Item className="form-item" name="archive">
                          <UploadDoc
                            carregarDocumentosExistents={
                              carregarDocumentosExistents
                            }
                            setFileId={setFileId}
                            isTaskId={isTaskId}
                            formulario={formulario}
                          />
                        </Form.Item>
                      </div>
                      {exporting ? (
                        <div
                          style={{
                            margin: 20,
                            width: "100%",
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress
                            className="cicleProgress"
                            disableShrink
                          />
                        </div>
                      ) : (
                        <div className="files-content">
                            <div style={{display: "flex", padding: 10, fontWeight: 700, color: "#727272"}}>
                              <div style={{width: "100%"}}>Arquivo</div>
                              <div style={{width: 80}}>Ações</div>
                            </div>
                          
                          {documentos.map((documento, index) => (
                            <div key={index}>
                              <div style={{display: "flex", border: "none", borderRadius: 14, boxShadow: "0 4px 10px #00000014", padding: 10, marginBottom:10 }}>
                                <div style={{color: "#868686", justifyContent: "left", display: "flex", alignItems: "center", width: "100%" }}>
                                  {documento.split("\\").pop()}
                                </div>
                                <div style={{display: "flex"}}>

                                  <Tooltip title="Visualizar">
                                    <div className="btn-padroa-editar" onClick={() => handleView(documento, index)}>
                                      <IoEyeOutline />
                                    </div>
                                  </Tooltip>

                                  <Tooltip title="Download">
                                    <div className="btn-padroa-editar" onClick={() => handleDownload(documento)}>
                                      <DownloadOutlined />
                                    </div>
                                  </Tooltip>

                                  <Tooltip title="Excluir">
                                    <div className="btn-remove-" onClick={() => showModalDelete(documento)}>
                                      <DeleteOutlined />
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {open && (
                        <>
                          <Modal
                            title="Excluir arquivo"
                            open={open}
                            onOk={handleDelete}
                            confirmLoading={confirmLoading}
                            onCancel={() => setOpen(false)}
                            okText="Excluir"
                            cancelText="Fechar"
                          >
                            <div style={{ display: "flex" }}>
                              <ExclamationCircleOutlined className="exclamation-icon" />
                              <p>Tem certeza que deseja excluir o arquivo?</p>
                            </div>
                          </Modal>
                        </>
                      )}
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {formulario.usuarioEmissao !== "pim" && (
                          <Flex gap="small" wrap>
                            <Button
                              style={{
                                background: "#005A9E",
                                color: "#fff",
                                margin: 3,
                              }}
                              loading={loadings[0]}
                              onClick={() => setIsModalDeleteOpen(true)}
                            >
                              <DeleteOutlined /> Excluir
                            </Button>
                          </Flex>
                        )}
                        <Flex gap="small" wrap>
                          <Button
                            style={{
                              background: "#005A9E",
                              color: "#fff",
                              margin: 3,
                            }}
                            loading={loadings[0]}
                            onClick={() => enterLoading(0)}
                          >
                            <SaveOutlined /> Salvar
                          </Button>
                        </Flex>
                      </div>

                      {isTarefaCorrelacionada && (
                        <TabelaCorrelacionadas
                          tarefasCorrelacionadas={tarefasCorrelacionadas}
                          setLoadings={setLoadings}
                          consultarObrigacao={consultarObrigacao}
                          setIsTarefaCorrelacionada={setIsTarefaCorrelacionada}
                          armazCorrelacionais={armazCorrelacionais}
                          taskId={taskId}
                        />
                      )}
                    </FormContent>
                  )}
                </>
              )}

              {selectedOption === "credenciais" && (
                <CredenciaisAcesso clienteId={formulario.clienteId} />
              )}

              {selectedOption === "das" && (
                <NotaFiscal
                  onClose={handleClose}
                  idClient={formulario.clienteId}
                />
              )}
            </>
          </Form>
          {isModalDeleteOpen && (
            <ModalExcluirTarefa
              isOpen={isModalDeleteOpen}
              onClose={handleClose}
              taskId={taskId}
              emitidas={emitidas}
              pendentes={pendentes}
              id={id}
              recorrencia={recorrencia}
              data={data}
              clienteId={clienteId}
            />
          )}

          {isModalAddInformacoesAdicionais && (
            <ModalAdicionarInformacoes
              formulario={formulario}
              isModalAddInformacoesAdicionais={isModalAddInformacoesAdicionais}
              setIsModalAddInformacoesAdicionais={
                setIsModalAddInformacoesAdicionais
              }
            />
          )}
        </div>
      </Modal>
    );
}

export default EmitidasEditar;
